import { apiGet, apiPost, apiPut } from "@redriver/cinnamon";

const NAMESPACE = "DEALER_OFFICE_ADDITIONAL_DOCUMENTS";

export const ActionTypes = {
  GetIntroductionTemplates: `${NAMESPACE}/GET_INTRODUCTION_TEMPLATES`,
  GetAssignmentTemplatesSPV: `${NAMESPACE}/GET_ASSIGNMENT_TEMPLATES_SPV`,
  GetAssignmentTemplatesCustomer: `${NAMESPACE}/GET_ASSIGNMENT_TEMPLATES_CUSTOMER`,
  UploadIntroductionTemplate: `${NAMESPACE}/UPLOAD_INTRODUCTION_TEMPLATE`,
  UploadAssignmentTemplateSPV: `${NAMESPACE}/UPLOAD_ASSIGNMENT_TEMPLATE_SPV`,
  UploadAssignmentTemplateCustomer: `${NAMESPACE}/UPLOAD_ASSIGNMENT_TEMPLATE_CUSTOMER`,
  ApproveAdditionalDocument: `${NAMESPACE}/APPROVE_ADDITIONAL_DOCUMENT`,
  DownloadAdditionalDocument: `${NAMESPACE}/DOWNLOAD_ADDITIONAL_DOCUMENT`,
};

export const getIntroductionTemplates = (dealerOfficeId) =>
  apiGet(
    ActionTypes.GetIntroductionTemplates,
    `dealer-offices/${dealerOfficeId}/additional-documents`,
    { type: "IntroductionTemplate" },
  );

export const getAssignmentTemplatesSPV = (dealerOfficeId) =>
  apiGet(
    ActionTypes.GetAssignmentTemplatesSPV,
    `dealer-offices/${dealerOfficeId}/additional-documents`,
    { type: "AssignmentTemplateSpv" },
  );

export const getAssignmentTemplatesCustomer = (dealerOfficeId) =>
  apiGet(
    ActionTypes.GetAssignmentTemplatesCustomer,
    `dealer-offices/${dealerOfficeId}/additional-documents`,
    { type: "AssignmentTemplateCustomer" },
  );

const uploadTemplate =
  (actionType, urlPath) =>
  ({ templateUpload, reference }, { dealerOfficeId, uploadDoc }) => {
    const fileUploadObject = !uploadDoc
      ? null
      : {
          name: templateUpload.name,
          content: uploadDoc.split(",")[1],
          size: templateUpload.size,
          contentType: templateUpload.type,
        };
    return apiPost(
      actionType,
      `dealer-offices/${dealerOfficeId}/${urlPath}/upload`,
      { Data: fileUploadObject, Reference: reference },
    );
  };

export const uploadIntroductionTemplate = uploadTemplate(
  ActionTypes.UploadIntroductionTemplate,
  "introduction-template",
);

export const uploadAssignmentTemplateSPV = uploadTemplate(
  ActionTypes.UploadAssignmentTemplateSPV,
  "assignment-template-spv",
);

export const uploadAssignmentTemplateCustomer = uploadTemplate(
  ActionTypes.UploadAssignmentTemplateCustomer,
  "assignment-template-customer",
);

export const approveAdditionalDocument = ({ id }) =>
  apiPut(
    ActionTypes.ApproveAdditionalDocument,
    `additional-document/${id}/approve`,
  );

export const downloadAdditionalDocument = ({ id }) =>
  apiGet(
    ActionTypes.DownloadAdditionalDocument,
    `additional-document/${id}/download`,
  );
